import type { FaireProductEntity } from "../../entity_types/product";

export const p_6cyf48udxx: FaireProductEntity = {
  token: "p_6cyf48udxx",
  type: "product",
  name: "Easily Distracted By Butts Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/50a2b2a61a113caf9af383d190ffb424009f1968c7f3cef473590319cb4812b4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a10fd760c26908b7afce2bb76e8a33f8fb25c10150592760ff4ea8880b46f805.jpeg",
    "https://cdn.faire.com/fastly/8682f48dcd60c433495c4822de77e03d0bf62163ae7511041998e1f25bbcc1be.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/bae358c434d06a58579a7e5c218aae459548ec353be807f1eafc647b16a8ba6e.jpeg",
    "https://cdn.faire.com/fastly/c54f2f246e92f080a56ff03a86f4f89d1b88497ccf0b8b6b31b9965ab561a263.jpeg",
    "https://cdn.faire.com/fastly/c45fc3faf3aeb90fe9e41dee15e96d7573fb269e6b6fdcfadba618381d87b717.jpeg",
    "https://cdn.faire.com/fastly/dc3c9978b102e0bdf368cd2e63b03612147d2d5900591764c226dfb66f7bd695.jpeg"
  ],
  priceDollars: 6.75,
  description: "We all try our best to concentrate... unless a cheeky distraction saunters by. 🍑 👀\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:29.665Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
